// @ts-nocheck - Legacy file with extensive type issues requiring comprehensive refactoring (TODO: GXM-XXXX)
import React, { useEffect, useRef, useState } from "react";
import { z } from "zod";
import { useShareHolderDetails } from "./ShareHolderDetail";
import API_ROUTES from "~/api-routes";
import apiService from "~/services/service";
import useShareholderForm from "./useShareholderForm";

const useShareHolderPersonalInfo = (type) => {
  const [isEditing, setIsEditing] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const formResetRef = useRef(null);
  const [isAuditSidebarVisible, setAuditSidebarVisible] = useState(false);
  const [shareholderType, setShareholderType] = useState(null);
  const {
    regData: initialShareholderData,
    setRegData,
    resetRegData: resetShareholderData,
  } = useShareHolderDetails();

  const [regData, localSetRegData] = useState(initialShareholderData || {});
  const { btnToggle, setBtnToggle, formDetails, setFormDetails } =
    useShareholderForm({
      setShowDialog,
      regData,
      setRegData: localSetRegData,
      resetRegData: resetShareholderData,
    });
  useEffect(() => {
    if (regData?.type && !shareholderType) {
      setShareholderType(regData?.type);
    }
  }, [regData]);

  useEffect(() => {
    localSetRegData(initialShareholderData || {});
    setFormDetails(initialShareholderData || {});
  }, [initialShareholderData]);

  useEffect(() => {
    setIsSaveDisabled(
      JSON.stringify(regData) === JSON.stringify(initialShareholderData),
    );
  }, [regData, initialShareholderData]);

  const handleEditClick = () => {
    setIsEditing(true);
    setSuccessMessage("");
    setIsSaveDisabled(true);
  };

  const handleDiscardClick = () => {
    resetShareholderData(initialShareholderData);
    localSetRegData(initialShareholderData);
    setFormDetails(initialShareholderData);
    setIsEditing(false);
    if (formResetRef.current) {
      formResetRef.current(initialShareholderData);
    }
  };

  const handleSaveClick = async () => {
    setIsLoading(true);
    let updatedShareholderData = {};
    if (regData?.type === "Individual") {
      updatedShareholderData = {
        type: regData?.type,
        name: regData?.name || "",
        last_name: regData?.last_name || "",
        other_name: regData?.other_name || "",
        preferred_name: regData?.preferred_name || "",
        legal_name: regData?.legal_name || "",
        email: regData?.email || "",
        phone: regData?.phone || "",
        phone_code: regData?.phone_code || "",
        point_of_contact: regData?.point_of_contact || "",
        ...(regData.status && {
          status: regData?.status?.code
            ? regData?.status?.code
            : regData?.status || "",
        }),
        nationality: regData?.nationality?.code
          ? regData?.nationality?.code
          : regData?.nationality || "",
        contact_email: regData?.contact_email || "",
        tax_identification_no: regData?.tax_identification_no || "",
        local_tax_id: regData?.local_tax_id || "",
        entity: regData?.entity || "",
        ...(regData?.date_of_birth && { date_of_birth: regData.date_of_birth }),
        ...(regData?.legal_structure && {
          legal_structure: regData.legal_structure,
        }),
        passport_number: regData?.passport_number || "",
        country_of_issue: regData?.country_of_issue || "",
        expiry_date: regData?.expiry_date || null,
        social_security_number: regData?.social_security_number || "",
      };
    } else {
      updatedShareholderData = {
        type: regData?.type,
        incorporation_country: regData?.incorporation_country?.code
          ? regData?.incorporation_country?.code
          : regData?.incorporation_country || null,
        company_registration_no: regData?.company_registration_no || "",
        email: regData?.email || null,
        entity: regData?.entity || "",
        legal_name: regData?.legal_name || "",
        ...(regData.status && {
          status: regData?.status?.code
            ? regData?.status?.code
            : regData?.status || "",
        }),
        phone: regData?.phone || null,
        phone_code: regData?.phone_code || null,
        point_of_contact: regData?.point_of_contact || null,
        contact_email: regData?.contact_email || null,
        ...(regData?.legal_structure && {
          legal_structure: regData.legal_structure.code,
        }),
      };
    }
    try {
      const res = await apiService(API_ROUTES.UPDATE_SHAREHOLDER, "PUT", {
        body: JSON.stringify(updatedShareholderData),
        replace: { id: initialShareholderData.id },
        schema: z.object({
          id: z.string(),
        }),
      });

      if (res.status) {
        setRegData(regData);
        localSetRegData(regData);
        setFormDetails(regData);
        setIsEditing(false);
        setIsSaveDisabled(true);
        if (formResetRef.current) {
          formResetRef.current(regData);
        }
        setSuccessMessage("Shareholder Information has been updated");
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  return {
    type,
    regData,
    isEditing,
    localSetRegData,
    formResetRef,
    setIsEditing,
    successMessage,
    setSuccessMessage,
    isSaveDisabled,
    setIsSaveDisabled,
    isLoading,
    setIsLoading,
    showDialog,
    setShowDialog,
    handleEditClick,
    handleDiscardClick,
    handleSaveClick,
    btnToggle,
    setBtnToggle,
    formDetails,
    setFormDetails,
    isAuditSidebarVisible,
    setAuditSidebarVisible,
    shareholderType,
    setShareholderType,
  };
};

export default useShareHolderPersonalInfo;
